type CommonLocation = {
  name_ru: string;
  name_en: string;
  name_kk: string;
  name: string;
  code: string;
};

export enum LocationType {
  COUNTRY = 'country',
  CITY = 'city',
  AIRPORT = 'airport',
}

export type MappedCountry = {
  type: LocationType.COUNTRY;
} & CommonLocation;

export type MappedAirport = {
  type: LocationType.AIRPORT;
  codeForBackend: string;
  city: { type: LocationType.CITY } & CommonLocation;
  country: MappedCountry;
} & CommonLocation;

export type MappedCity = {
  type: LocationType.CITY;
  country: MappedCountry;
  children?: MappedAirport[];
} & CommonLocation;

export type MappedLocation = MappedAirport | MappedCity;
